var path = 'app/scripts/modules/amazon/src/serverGroup/configure/wizard/securityGroups/securityGroups.html';
var html = "<div class=\"row\" ng-if=\"state.loaded\">\n  <server-group-security-groups-removed command=\"command\"></server-group-security-groups-removed>\n  <server-group-security-group-selector command=\"command\"\n                                        groups-to-edit=\"command.securityGroups\"\n                                        available-groups=\"command.backingData.filtered.securityGroups\"></server-group-security-group-selector>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/serverGroup/configure/wizard/securityGroups/securityGroups.html
// module id = 1244
// module chunks = 0